import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useAxiosClient } from '../../hooks/useAxiosClient';
import { Link } from 'gatsby';
import LoadingSpinner from '../LoadingSpinner';

const EfpaLink = (props) => {
  const {
    mode = 'link',
    to,
    onClick,
    state = null,
    className,
    italic,
    endpoint,
    resField,
    params,
    method = 'GET',
    data,
    name,
    replace
  } = props;
  const [loading, setLoading] = useState(false);

  const [, triggerRequest] = useAxiosClient(
    {},
    {
      manual: true,
    }
  );

  const handleClick = (e) => {
    e.preventDefault();
    if (typeof onClick === 'function' && onClick) onClick({ target: { name } });
  };

  const fetchUrl = async (e) => {
    e.preventDefault();
    setLoading(true);
    triggerRequest({
      url: endpoint,
      params,
      method,
      data,
    })
      .then(({ data: res }) => {
        setLoading(false);
        if (res && res[resField])
          return (
            window &&
            window.open(res[resField], '_blank', 'noopener,noreferrer')
          );
      })
      .catch((e) => {
        setLoading(false);
        console.log('Error!', e);
      });
  };

  if (mode === 'button')
    return (
      <a
        href="#Redirect"
        onClick={handleClick}
        className={`EfpaLink ${italic ? 'italic' : ''} ${className || ''}`}
      >
        {props.children}
      </a>
    );
  if (mode === 'request')
    return (
      <a
        href="#Redirect"
        onClick={fetchUrl}
        className={`EfpaLink ${italic ? 'italic' : ''} ${className || ''}`}
      >
        {props.children}
        <LoadingSpinner hide={!loading} />
      </a>
    );
  if (mode === 'link')
    return (
      <Link
        to={to}
        state={state}
        className={`EfpaLink ${italic ? 'italic' : ''} ${className || ''}`}
        replace={replace}
      >
        {props.children}
      </Link>
    );
  if (mode === 'outsideLink')
    return (
      <a
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        className={`EfpaLink ${italic ? 'italic' : ''} ${className || ''}`}
        k
      >
        {props.children}
      </a>
    );
  return null;
};

EfpaLink.propTypes = {
  mode: PropTypes.oneOf(['button', 'link', 'outsideLink', 'request'])
    .isRequired,
  to: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  state: PropTypes.object,
  italic: PropTypes.bool,
  replace: PropTypes.bool,
  endpoint: PropTypes.string,
  resField: PropTypes.string,
  method: PropTypes.string,
  name: PropTypes.string,
  params: PropTypes.object,
  data: PropTypes.object,
};

export default EfpaLink;
